import type { CSSProperties } from 'react'

export interface SpinnerProps {
  size: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeMap: Record<SpinnerProps['size'], number> = {
  sm: 16,
  md: 24,
  lg: 48,
}

const spinnerKeyframes = `
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`

export function Spinner({ size, className }: SpinnerProps) {
  const dimension = sizeMap[size]
  const strokeWidth = size === 'lg' ? 3 : 2

  const containerStyles: CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: dimension,
    height: dimension,
  }

  const svgStyles: CSSProperties = {
    animation: 'spin 1s linear infinite',
  }

  return (
    <>
      <style>{spinnerKeyframes}</style>
      <span className={className} style={containerStyles} role="status" aria-label="Loading">
        <svg
          width={dimension}
          height={dimension}
          viewBox="0 0 24 24"
          fill="none"
          style={svgStyles}
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" stroke="var(--color-paper)" strokeWidth={strokeWidth} />
          <path
            d="M12 2a10 10 0 0 1 10 10"
            stroke="var(--color-accent)"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
        </svg>
      </span>
    </>
  )
}
